export class ApplicationConstants {
    static debounceTimeInMilliSeconds = 500;
}